import React, { Component } from 'react';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import IconButton from '@mui/material/IconButton';
import cross from '../../assets/icons/cross.png';

class Notification extends Component {
  render() {
    const { open, message, duration, onClose, notificationType, anchorOrigin } = this.props;

    return (
      <span>
        <Snackbar open={open} autoHideDuration={duration || 5000} onClose={onClose} anchorOrigin={anchorOrigin}>
          <SnackbarContent
            className={`snackbar-notification notification-${notificationType}`}
            aria-describedby="client-snackbar"
            message={message}
            action={[
              <IconButton key="close" aria-label="Close" color="inherit" onClick={onClose}>
                <img src={cross} alt="Close button" className="notification-icon" />
              </IconButton>
            ]}
          />
        </Snackbar>
      </span>
    );
  }
}

export default Notification;
